/**
 * Tipos de Cena (espelha api/src/types/cena.ts).
 *
 * Cada cena vira UM video_input no HeyGen. Editor permite mexer livre.
 */

export type Emotion = 'Excited' | 'Friendly' | 'Serious' | 'Soothing' | 'Broadcaster';
export type AvatarStyle = 'normal' | 'circle' | 'closeUp';

export interface CenaFala {
  tipo: 'fala';
  texto: string;
  emotion?: Emotion;
  speed?: number;
  pitch?: number;
  avatarStyle?: AvatarStyle;
  razao?: string;
}

export interface CenaPausa {
  tipo: 'pausa';
  duracao: number;
  razao?: string;
}

export interface CenaBroll {
  tipo: 'broll';
  duracao: number;
  imagemPrompt?: string;
  imagemUrl?: string;
  imagemAssetId?: string;
  fonte?: 'ia' | 'upload' | 'pular';
  razao?: string;
}

export type Cena = CenaFala | CenaPausa | CenaBroll;

export interface RoteiroDirector {
  cenas: Cena[];
  resumoEstrutura?: string;
  duracaoEstimadaSeg?: number;
}

export interface VideoTemplate {
  id: string;
  nome: string;
  descricao: string | null;
  configJson: {
    avatarId: string;
    voiceId: string;
    aspectRatio: '16:9' | '9:16' | '1:1';
    background: string;
  };
  cenasJson: Cena[];
  criadoEm: string;
  atualizadoEm: string;
}

export const EMOTIONS: Emotion[] = ['Excited', 'Friendly', 'Serious', 'Soothing', 'Broadcaster'];
export const AVATAR_STYLES: AvatarStyle[] = ['normal', 'circle', 'closeUp'];
